import { connect } from 'react-redux';
import CompletedProjects from 'profile/components/completed_projects';

export function mapStateToProps({ user, categories, profile }) {
  const { completedProjects, is_client } = profile.view.data;
  return {
    user,
    categories: categories ? categories.data : [],
    completedProjects,
    is_client
  };
}

export default connect(mapStateToProps)(CompletedProjects);



// WEBPACK FOOTER //
// ./profile/containers/completed_projects.js